const InfoTooltip = require('./infoTooltip');
const HelpTooltip = require('./helpTooltip');
const CustomTooltip = require('./customTooltip');

export default {
    InfoTooltip,
    HelpTooltip,
    CustomTooltip,
};
